export default {
  seo: {
    title: 'SEO Settings',
    types: {
      defaultGlobe: 'Global Default',
      home: 'Home',
      // compat old keys
      promotionList: 'Promotion List',
      promotionDetail: 'Promotion Detail',
      pointsMall: 'Points Mall',
      aiRecommend: 'AI Recommend',
      helpCenter: 'Help Center',
      helpArticleDetail: 'Help Article Detail',
      // new backend typeKey
      'promo-list': 'Promotion List',
      'promo-detail': 'Promotion Detail',
      points: 'Points Mall',
      'ai-picks': 'AI Picks',
      'help-index': 'Help Center',
      'help-article': 'Help Article Detail',
      vip: 'VIP Page',
      'vip-rules': 'VIP Rules'
    },
    form: {
      searchLabel: 'Search',
      searchPlaceholder: 'Search by name / keyword',
      query: 'Query',
      reset: 'Reset',
      add: 'New Page',
      languageLabel: 'Language',
      languagePh: 'Select language',
      typeLabel: 'Page Type',
      typeAll: 'All',
      statusLabel: 'Status',
      statusAll: 'All',
      statusEnabled: 'Enabled',
      statusDisabled: 'Disabled'
    },
    table: {
      name: 'Page Name',
      isGlobalTag: 'Global',
      dynamicParams: 'Dynamic Params',
      yes: 'Yes',
      no: 'No',
      coreSeo: 'Core SEO',
      socialOg: 'Social OG',
      enabled: 'Enabled',
      action: 'Action',
      edit: 'Edit',
      preview: 'Preview',
      delete: 'Delete',
      total: 'Total {{count}} items',
      updatedByText: 'Updated: {{updatedAt}} · By: {{updatedBy}}',
      keywordPrefix: 'Keyword: {{text}}',
      ogImageHas: 'Image',
      ogImageNone: 'No Image',
      ogTitleShort: 'OGT: {{text}}',
      ogDescShort: 'OGD: {{text}}',
      ogKeywordShort: 'OGK: {{text}}',
      ogImageConfigured: 'Configured',
      ogImageNotConfigured: 'Not Configured'
    },
    modal: {
      createTitle: 'Create Page',
      editTitle: 'Edit Page',
      previewTitle: 'Preview',
      fields: {
        type: 'Page Type',
        typePh: 'Select page type',
        name: 'Page Name',
        namePh: 'Unique identifier, e.g. home, promotion-detail',
        enabled: 'Enabled',
        isGlobal: 'Global',
        hasOG: 'Has OG Info',
        hasDynamicParams: 'Has Dynamic Params',
        paramNames: 'Param Names',
        paramNamesPh: 'e.g. id, slug (comma separated)',
        title: 'Title',
        titlePh: 'Supports {{pageTitle}}',
        meta: 'Meta Description',
        metaPh: 'Page summary',
        canonical: 'Canonical',
        canonicalPh: 'Canonical link',
        keyword: 'Keyword',
        keywordPh: 'Comma separated',
        ogTitle: 'OG Title',
        ogDesc: 'OG Description',
        ogKeyword: 'OG Keyword',
        ogImage: 'OG Image URL',
        ogImagePh: 'https://...'
      },
      ok: 'OK',
      cancel: 'Cancel',
      deleteConfirmTitle: 'Delete Confirm',
      deleteConfirmContent: 'Delete page "{{name}}"?'
    },
    message: {
      queryFailed: 'Query failed',
      createSuccess: 'Created',
      createFailed: 'Create failed',
      updateSuccess: 'Updated',
      updateFailed: 'Update failed',
      opFailed: 'Operation failed',
      enabled: 'Enabled',
      disabled: 'Disabled',
      deleteSuccess: 'Deleted',
      deleteFailed: 'Delete failed'
    }
  }
};


